"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = {
    'whatsapp.trackLog.status.neutral': 'Neutralny',
    'whatsapp.trackLog.status.good': 'Dobry',
    'whatsapp.trackLog.status.warning': 'Ostrzeżenie',
    'whatsapp.trackLog.status.critical': 'Krytyczny',
    'whatsapp.trackLog.type': 'Typ:',
    'whatsapp.trackLog.goToSource': 'Przejdź do źródła',
};
